@use '../../../styles/Variables' as *;

.cancel-button.MuiButton-root {
  border-radius: 8px;
  background-color: $neutral-dark-10;
  color: $text-color-dark;
  box-shadow: none;

  &:hover {
    background-color: $neutral-dark-10-hover;
  }
}
